import {get} from "lodash"

export default function getCodeFromError(err: any): string {
  // if there is a config property, it was probably an axios request
  const fallback = err?.config ? "Network Error" : ""

  return (
    attemptToGetCode(err) || fallback // we have no idea
  )
}

/**
 * @description: low level functionality to find a potential error code,
 * you should probably use `getCodeFromError()` instead
 */
export function attemptToGetCode(err: any): string | undefined {
  return (
    err?.code || // simple assign
    err?.errorCode || // graph response
    get(err, "response.data.code") || // REST API response
    // Adding back the following lines to attempt to get error code from apollo client errors, which have a different format. This is needed for the logout on error logic to work correctly.
    get(err, "data.errors[0].errorCode") || //  apollo client raw error
    get(err, "data.response.errors[0].errorCode") || // apollo client error
    get(err, "networkError.response.data.errors[0].errorCode") ||
    get(err, "networkError.response") || // low level apollo error
    get(err, "graphQLErrors[0].errorCode") || // mid level apollo error
    undefined
  )
}
